import { TagSortBy } from "~frontend/__generated__/graphql";

export const TAG_SORTS = [
  {
    value: TagSortBy.CreatedAtDesc,
    label: "Created At, Newest First",
  },
  {
    value: TagSortBy.CreatedAtAsc,
    label: "Created At, Oldest First",
  },
  {
    value: TagSortBy.NameAsc,
    label: "Name, A-Z",
  },
  {
    value: TagSortBy.NameDesc,
    label: "Name, Z-A",
  },
];
